import React, { useEffect, useRef } from "react";
import { ViewportPortal } from "../shared/ViewportDialog";
import { ActiveCrewList } from "./ActiveCrewList";
import { SNAPSHOT_CARD_TITLE_STYLE } from "./SnapshotMetricCard";

/**
 * Full-screen overlay for browsing active crew. Opened from Crew Snapshot rows.
 */
export function ActiveCrewListModal({
  open,
  title,
  crewList,
  emptyMessage,
  onSelectCrew,
  onClose,
}) {
  const backdropRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return;
    }

    requestAnimationFrame(() => {
      if (backdropRef.current) {
        backdropRef.current.scrollTop = 0;
      }
    });
  }, [open, title]);

  if (!open) {
    return null;
  }

  const handleSelectCrew = (crew) => {
    setTimeout(() => {
      onSelectCrew(crew);
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }, 250);
  };

  return (
    <ViewportPortal open={open}>
    <div
      ref={backdropRef}
      className="kpi-active-crew-modal-backdrop"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.8)",
        zIndex: 9998,
        padding: "20px",
        overflowY: "auto",
      }}
      onClick={onClose}
    >
      <div
        className="kpi-active-crew-details-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ ...SNAPSHOT_CARD_TITLE_STYLE, color: "#e4c56a" }}>{title}</div>
        <ActiveCrewList
          crewList={crewList}
          onSelectCrew={handleSelectCrew}
          emptyMessage={emptyMessage}
        />
        <button className="kpi-back-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
    </ViewportPortal>
  );
}
